import { FC, memo } from "react";
import { Stack } from "@mui/material";
import { AccountsViewToggle } from "./AccountsViewToggle";
import { AccountSortBy } from "./AccountSortBy";
import { AccountsSearch } from "./AccountsSearch";
import { AccountTabs } from "../../../utils/types/types";
import { ProviderType } from "../../../../../../services/cloudchipr.api";

interface AccountsToolbarProps {
  provider: ProviderType;
  tabValue: AccountTabs;
}

export const AccountsToolbar: FC<AccountsToolbarProps> = memo(
  ({ provider, tabValue }) => {
    return (
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <AccountsSearch />

        <Stack direction="row" spacing={3}>
          <AccountSortBy tabValue={tabValue} provider={provider} />
          <AccountsViewToggle tabValue={tabValue} provider={provider} />
        </Stack>
      </Stack>
    );
  },
);
